<style>
    .form-control-file, .form-control-range {
        display: block;
        width: 100%;
        padding: 0.375rem 0.75rem;
        line-height: 2.5;
        border-radius: 0 0.25rem 0.25rem 0;
        color: #768192;
        background-color: #ebedef;
    }
</style>
<template>
    <div>
        <CRow class="mb-3 ml-2">
            <h3>미납잔액 일괄등록 </h3>
        </CRow>
        <CRow style="margin-left: 2%; margin-bottom: 2%; margin-top: 2%;">
            <CInputFile  label="" horizontal @change="onChangedFile" v-if="uploadReady" accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"/>
            <CSpinner color="success" v-show="loading"/>
        </CRow>
        <!--<CRow style="margin-left: 2%; margin-top: 5%;">
            <label><strong>등록 방식을 선택해 주세요.</strong></label>
        </CRow>-->

        <table class="table table-responsive" style="margin-left: 2%; margin-top: 1%;">
            <tbody>
                <tr>
                   <!-- <td style="width: 20%;">
                        <div class="radio radiotext">
                            <label><input type="radio" id='regular' name="optradio" v-model="regType" value="P">&nbsp;부분 등록</label>
                        </div>
                    </td>-->
                    <td style="width: 60%;">
                        <div class="radiotext">
                            <label for='regular'>
                                ※ 작성된 파일을 선택하여 일괄등록 처리합니다.
                                <br/>※ [양식 다운로드]버튼 클릭시 엑셀파일에 기본정보(대상자 정보)가 포함되며 미납잔액 등록시 해당금액만 남기고,  기존 등록된 미납금액은 자동 결제처리됩니다.
                            </label>
                        </div>
                    </td>
                    <td style="width: 20%;">
                        <button type="button"
                                class="btn btn-info btn-block"
                                @click="downloadTemplate">
                             양식 다운로드</button>
                    </td>
                </tr>
               <!-- <tr>
                    <td>
                        <div class="radio  radiotext">
                            <label><input type="radio" id='express' name="optradio" v-model="regType" value="A">&nbsp;전체 등록</label>
                        </div>
                    </td>
                    <td>
                        <div class="radiotext">
                            <label for='express'>
                                - 모든 환자 정보를 새로운 정보로 변경합니다.
                                <br>- 엑셀 파일에 없는 환자는 모두 퇴원 처리됩니다
                                <br/>- 청구액이 있는 경우 금액을 추가로 청구합니다.
                            </label>
                        </div>
                    </td>
                    <td>
                        <button label=""
                                type="button"
                                class="btn btn-info btn-block"
                                @click="downloadWholeUser">
                            모든환자정보 다운로드</button>
                    </td>
                </tr>-->
            </tbody>
        </table>
        <CRow>
            <CCol class="btn-col-margin ml-4" sm="1">
                <button label=""
                        type="button"
                        class="btn btn-info btn-block"
                        @click="goUploadProc">
                        다 음</button>
            </CCol>
            <CCol class="btn-col-margin ml-4" sm="1">
                    <button label=""
                            type="button"
                            class="btn btn-info btn-block"
                            @click="back">닫 기
                    </button>
            </CCol>
        </CRow>
    </div>
</template>
<link rel="stylesheet" href="https://maxcdn.bootstrapcdn.com/bootstrap/3.3.5/css/bootstrap.min.css" />
<style>
    .btn-col-margin{
        margin-top: 5px;
        margin-left: 15px;
        margin-right: 10px;
    }
    .col-title{
        width: 20%;
    }
    .table-span-margin{
        margin-left: 10%;
    }
    .radiotext {
        margin: 10px 10px 0px 0px;
    }
</style>
<script>
    /*import CTableWrapper from './Table.vue'*/
    import CTableWrapper from "../base/PayManageInsertForm";
    import usersData from '../users/UsersData';
    import Table from "../base/Table";
    import axios from 'axios';
    import XLSX from 'xlsx';

    let excelFile;
    let dataArray;
    let validate = false;
    let validateMsg = "";

    export default {
        name: 'PayManageExcelUpload',
        components: {Table, CTableWrapper},
        data: function() {
            return {
                regType: 'P',
                loading: false,
                uploadReady: true
            };
        },
        methods: {
            shuffleArray(array) {
                for (let i = array.length - 1; i > 0; i--) {
                    let j = Math.floor(Math.random() * (i + 1));
                    let temp = array[i];
                    array[i] = array[j];
                    array[j] = temp
                }
                return array
            },
            getShuffledUsersData() {
                return this.shuffleArray(usersData.slice(0))
            },
            downloadTemplate() {
                axios.post('silver/cust/getRealCustUnpaidRegExcelTemplate', "", {
                    responseType: "blob",
                }).then(res => {
                    try {
                        let blob = new Blob([res.data], { type: res.headers['content-type'] });
                        //let fileName = this.getFileName(res.headers['content-disposition']);

                        //인코딩 문제로 파일이름 직업 삽입
                        let fileName ="미납잔액_일괄등록양식.xlsx";
                        // fileName = decodeURI(fileName); // 파일명 디코딩 (프로젝트에 따라 사용여부 옵션)

                        if (window.navigator.msSaveOrOpenBlob) { // IE 10+
                            window.navigator.msSaveOrOpenBlob(blob, fileName)
                        } else { // not IE
                            let link = document.createElement('a');
                            link.href = window.URL.createObjectURL(blob);
                            link.target = '_self';
                            if (fileName) link.download = fileName;
                            link.click();
                            link.remove();
                        }
                    } catch (e) {
                        console.error(e)
                    }
                }).catch(error => {
                    console.log(error);
                });
            },
          /*  downloadWholeUser() {
                axios.post('silver/cust/getWholeCustListExcel', "", {
                    responseType: "blob",
                }).then(res => {
                    try {
                        let blob = new Blob([res.data], { type: res.headers['content-type'] });
                        let fileName = this.getFileName(res.headers['content-disposition']);
                        // fileName = decodeURI(fileName); // 파일명 디코딩 (프로젝트에 따라 사용여부 옵션)

                        if (window.navigator.msSaveOrOpenBlob) { // IE 10+
                            window.navigator.msSaveOrOpenBlob(blob, fileName)
                        } else { // not IE
                            let link = document.createElement('a');
                            link.href = window.URL.createObjectURL(blob);
                            link.target = '_self';
                            if (fileName) link.download = fileName;
                            link.click();
                            link.remove();
                        }
                    } catch (e) {
                        console.error(e)
                    }
                }).catch(error => {
                    console.log(error);
                });
            },*/
            getFileName (contentDisposition) {
                let fileName = contentDisposition
                    .split(';')
                    .filter((ele) => {
                        return ele.toLowerCase().indexOf('filename') > -1
                    })
                    .map((ele) => {
                        return ele
                            .replace(/"/g, '')
                            .split('=')[1]
                    });
                return fileName[0] ? fileName[0] : null
            },
            goUploadProc() {
                const regType = 'P';

                if (this.excelFile === undefined || this.excelFile.length < 1) {
                    alert("파일을 등록하세요!");
                    return;
                }

                const fileName = this.excelFile[0].name;
                if (fileName.lastIndexOf(".") < 0) {
                    alert("엑셀 파일을 등록하세요!");
                    return;
                }

                const extName = fileName.substring(fileName.lastIndexOf(".") + 1);
                if (!(extName.toLowerCase() == "xlsx" || extName.toLowerCase() == "xls")) {
                    alert("엑셀 파일을 등록하세요!");
                    return;
                }

                if (this.dataArray === undefined || this.dataArray.length < 1) {
                    alert("파일 데이터가 없습니다!");
                    return;
                }

                if (this.loading) {
                    alert("잠시 후 다시 시도해주세요!");
                    return;
                }

                if (this.validate == false) {
                    alert(this.validateMsg);
                    return;
                }

                this.$router.push({name:"offlineunpaidchargeexcelproc", params: {regType: regType, dataArray: this.dataArray}});
            },
            back() {
                this.$router.push({name:"paymanagementlist"})
            },
            onChangedFile(files, event) {
                this.excelFile = files;

                // get File object from input tag
                const file = event.target.files[0];

                if (file === undefined) {
                    return;
                }

                // declare FileReader, temp result
                const reader = new FileReader();
                let tmpResult = {};

                // if you use "this", don't use "function(e) {...}"
                reader.onload = (e) => {
                    let data = reader.result;
                    data = new Uint8Array(data);
                    // get excel file
                    let excelFile = XLSX.read(data, { type: "array" });
                    // get prased object
                    excelFile.SheetNames.forEach(function(sheetName) {
                        const roa = XLSX.utils.sheet_to_json(
                            excelFile.Sheets[sheetName]
                            );

                        if (roa.length) {
                            tmpResult[sheetName] = roa;
                        }
                    });
                    //기본 상단 내용 제외하고 실제 데이터부터 자르기
                    this.dataArray = tmpResult[excelFile.SheetNames[0]].slice(5);

                    var chkRegist = [];

                    let alertMessage = "";
                    for (const dataIdx in this.dataArray) {
                        const json = this.dataArray[dataIdx];
                        let lastName = "";
                        let regNum = "";
                        Object.keys(json).forEach(function(key, idx) {
                            if (idx == 0) {
                                lastName = json[key].toString().trim();
                            } else if (idx == 1) {
                                regNum = json[key].toString().trim();
                                chkRegist.push(regNum);
                            } else if (idx == 2) {
                                const regexp = /^[0-9]*$/;

                                if(!regexp.test(json[key].toString().trim()) && json[key].toString().trim() != "") {
                                    alertMessage += lastName + "(" + regNum + ") 님의 청구액을 확인하세요! 숫자 형태로 작성하여야 합니다.\n";
                                }
                            }
                            /*  else if (idx == 3 || idx == 4) {
                               const regexp = /^[0-9]*$/;

                               if(!regexp.test(json[key].toString().trim()) || json[key].toString().trim().length != 8) {
                                   alertMessage += lastName + "(" + regNum + ") 님의 입원일, 퇴원일을 확인하세요! ex) 20200101 형태로 작성하여야 합니다.\n";
                               }
                           }*/
                            /* else if (idx == 5) {
                                 const regexp = /^[0-9]*$/;

                                 if(!regexp.test(json[key].toString().trim()) && json[key].toString().trim() != "") {
                                     alertMessage += lastName + "(" + regNum + ") 님의 청구액을 확인하세요! 숫자 형태로 작성하여야 합니다.\n";
                                 }
                             }*/
                        });
                    }
                    var valuesSoFar = [];
                    var falseLine=0;
                    for (var i = 0; i < chkRegist.length; ++i) {
                        var value = chkRegist[i];
                        if (valuesSoFar.indexOf(value) !== -1) {
                            falseLine = falseLine + 1;
                        }
                        valuesSoFar.push(value);
                    }

                    //중복 제거 필터
                    let single = valuesSoFar.filter( (item, idx, array) => {
                        return array.indexOf( item ) === idx ;
                    });

                    if(falseLine > 0){
                        alertMessage += "중복된 진료번호가 존재합니다.";
                    }

                    this.loading = false;

                    if (alertMessage != "") {
                        //validate 체크결과 alert
                        alert(alertMessage);
                        this.validateMsg = alertMessage;
                        this.validate = false;

                        //input file 초기화
                        this.uploadReady = false;
                        this.$nextTick(() => {
                            this.uploadReady = true
                        });

                        return;
                    }

                    this.validate = true;
                };
                reader.readAsArrayBuffer(file);
                this.loading = true;
            }
        }
    }
</script>
